import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _BoxRefreshAltRightLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "m12 12 4 4-4 4" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M13 8h4M16 16H8a4 4 0 0 1 0-8h1" })));
}
const BoxRefreshAltRightLight = forwardRef(_BoxRefreshAltRightLight);
export { BoxRefreshAltRightLight };
